import { render, staticRenderFns } from "./ThirdPartyBetContentFilterDialog.vue?vue&type=template&id=a3c96210"
import script from "./ThirdPartyBetContentFilterDialog.vue?vue&type=script&lang=js"
export * from "./ThirdPartyBetContentFilterDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports